/**
 * Role Guard
 * Компонент для защиты маршрутов, требующих определённой роли
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'shared/context/AuthContext';

/**
 * Компонент для защиты маршрутов по ролям
 * Проверяет роль пользователя и показывает контент или редирект
 */
export function RoleGuard({ requiredRole, children, fallback }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  console.log('[RoleGuard] Path:', location.pathname, '| Required:', requiredRole, '| User role:', user?.role);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    console.log('[RoleGuard] No user, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  if (user.role !== requiredRole) {
    console.log('[RoleGuard] Role mismatch, redirecting to dashboard');
    // Если требуется админ, а пользователь обычный - редирект на dashboard
    if (fallback) {
      return <>{fallback}</>;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

/**
 * Компонент для защиты маршрутов, требующих админ роли
 */
export function AdminGuard({ children, fallback }) {
  return (
    <RoleGuard requiredRole="admin" fallback={fallback}>
      {children}
    </RoleGuard>
  );
}

/**
 * Компонент для условного отображения контента на основе роли
 */
export function RoleBasedContent({ allowedRoles, children, fallback }) {
  const { user } = useAuth();

  if (!user || !allowedRoles.includes(user.role)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
